// export const baseURL = 'https://test.smg.orota.cn';  // 测试
export const baseURL = 'https://api.jj20xbape.com';  // 生产
// export const baseURL = '/api';